export default __webpack_public_path__ + "static/media/nine-dot-icon.a0f6da38.svg";